import styled from 'styled-components';

//helpers
import {transparentize} from '../../utils/color-utils';
import {commonPalette} from '../../styles/palette';
import {truncate} from '../../styles/partials';

export const EditableText = styled.div`
  ${truncate};
  border-radius: 2px;
  cursor: text;
  margin: -1px -8px;
  padding: 1px 8px;
  transition: 0.2s background ease-out;

  &:hover {
    background: ${transparentize('#ebebeb', 0.65)};
    transition: none;
  }
`;

export const Title = styled.label`
  display: block;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px;
`;

export const Error = styled.div`
  display: block;
  color: ${commonPalette.red};
  font-size: 12px;
  margin: ${p => (p.inline ? 0 : '12px 0')};
  line-height: ${p => (p.inline ? '40px' : '12px')};
  height: ${p => (p.inline ? 0 : '9px')};
  opacity: ${p => (p.visible ? 1 : 0)};
  ${({position}) => (position ? `position: ${position};` : '')}
  ${({left}) => (left ? `left: ${left};` : '')}
  ${({padding}) => (padding ? `padding: ${padding};` : '')}
  ${({margin}) => (margin ? `margin: ${margin};` : '')}
  ${({height}) => (height ? `height: ${height};` : '')}
`;
